import React from "react";

export default function Ticker({ items }) {
  const track = [...items, ...items]; // duplicate for seamless loop
  return (
    <div
      className="relative overflow-hidden border-y border-white/8 bg-[#0A0A0C]/60 backdrop-blur-sm"
      data-testid="live-ticker"
    >
      <div className="ticker-track py-3">
        {track.map((t, i) => (
          <div
            key={i}
            className="flex items-center gap-3 px-6 shrink-0 text-sm font-mono-tech"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-[#00FFD0] shadow-[0_0_10px_#00FFD0]" />
            <span className="text-[#D4D4D8] uppercase tracking-widest">{t}</span>
          </div>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0A0A0C] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0A0A0C] to-transparent" />
    </div>
  );
}
